import React from 'react';
import Icon from './Icon';

export default function WhatsAppFab({ bottom = 100, phone = '916353937571' }) {
  const href = `https://wa.me/${phone}?text=${encodeURIComponent("Hi Dr. Moksha, I'd like to ask about physiotherapy.")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp Dr. Moksha"
      style={{
        position: 'absolute', right: 18, bottom,
        width: 54, height: 54, borderRadius: 999, border: 'none',
        background: '#25D366', color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 8px 22px rgba(37,211,102,0.35), 0 2px 4px rgba(0,0,0,0.1)',
        zIndex: 30, textDecoration: 'none',
      }}
    >
      <Icon name="whatsapp" size={26} stroke="#fff" />
    </a>
  );
}
